<template>
  <main class="mt-5" id="page-store-balance">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش موجودی انبار</h5>
        <div style="flex: 1"></div>
      </div>
      <div class="row px-4 not-in-print">
        <b-form-group class="col-5">
          <multiselect
            placeholder="انتخاب انبار"
            v-model="selectedStore"
            open-direction="bottom"
            :options="stores"
            label="label"
            track-by="id"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            :disabled="disabled"
          >
            <template slot="noOptions"> موردی یافت نشد </template>
            <template slot="noResult"> موردی یافت نشد </template>
          </multiselect>
        </b-form-group>
        <div class="col-md-12">
          <div class="col-5">
            <b-form-group label="دسته بندی">
                <treeselect
                    :options="realOptions"
                    v-model="category_id"
                    :searchable="true"
                    :show-count="true"
                    noChildrenText="فرزندی وجود ندارد"
                    noOptionsText="موردی وجود ندارد"
                    noResultsText="موردی یافت نشد"
                    :default-expand-level="1"
                    label="title"
                >
                    <label
                    slot="option-label"
                    slot-scope="{
                        node,
                        shouldShowCount,
                        count,
                        labelClassName,
                        countClassName,
                    }"
                    :class="labelClassName"
                    >
                    {{ node.label }}
                    </label>
                </treeselect>
            </b-form-group>
        </div>
      </div>
        <ProductSearch
        class="col-md-12"
        ref="productSearch"
        :selectable="true"
        :store="selectedStore"
        :disabled="disabled"
        @selectProduct="selectProduct"
        :show-label="false"
        @selectVariety="selectVariety"
        />
        <b-button
          class="col-md-2"
          variant="primary"
          @click="doFilter"
          :disabled="disabled"
          >فیلترسازی</b-button
        >
      </div>
      <div id="print" class="p-4">
        <b-table
          id="main-table"
          bordered
          striped
          :fields="fields"
          :items="reports"
          responsive="sm"
        >
          <template v-slot:cell(purchase_price)="data">
            {{ data.item.purchase_price | price }}
          </template>
          <template v-slot:cell(sell_price)="data">
            {{ data.item.sell_price | price }}
          </template>
          <template v-slot:cell(title)="data">
            <a target="_blank" :href="'/admin/products/edit/' + data.item.id">{{
              data.item.title
            }}</a>
          </template>
          <template v-slot:cell(quantity)="data">
            {{ data.item.quantity | price }}
          </template>
          <template v-slot:cell(show)="data">
            <button
                style="display: flex;justify-content: center;align-items: center;border-radius: 5px;position: static;"
                data-toggle="modal"   
                data-target="#excel-modal"
                type="button"
                class="btn btn-primary btn-icon not-in-print"
                @click="showVarietiesBalance(data.item.id,data.item.title)"
              >
                <span class="fe fe-eye text-light"></span>
              </button>
            </template>
          <template #bottom-row="data">
            <b-td colspan="2">
              <div class="text-center">جمع کل</div>
            </b-td>
            <b-td>
              {{ totals.quantity | price }}
            </b-td>
            <b-td>
              {{ totals.purchase_price | price }} تومان</b-td
            >
            <b-td>
              {{ totals.sale_price | price }} تومان</b-td
            >
            <b-td>*</b-td>
          </template>
        </b-table>
      </div>
    </div>
    <div class="modal fade" id="excel-modal" v-if="isProduct" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-content-demo">
          <div class="modal-header">
              <p class="modal-title font-weight-bold">موجودی تنوع محصول ({{ productTitle }})</p>
              <button aria-label="Close" class="close" data-dismiss="modal"><span
                      aria-hidden="true">×</span></button>
          </div>
          <div class="modal-body">
            <div class="row p-4" v-if="varieties">
              <table class="table table-striped table-responsive-sm table-bordered table-hover">
                <thead class="bg-gray">
                    <tr>
                        <th>ردیف</th>
                        <th>تنوع</th>
                        <th>موجودی</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(variety,index) in varieties" :key="index">
                        <td class="font-weight-bold">{{ index + 1 }}</td>
                        <td>{{ variety[4] }}</td>
                        <td>
                          {{ variety[3].find(item => item.store_id == selectedStore.id) ? 
                          variety[3].find(item => item.store_id == selectedStore.id).balance : 0 }}  
                        </td>
                    </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-center align-items-center" style="width: 100%;">
                <Loading v-if="$root.isEmptyObject(varieties)" />
              </div>
            </div>  
          </div>  
        </div>  
      </div>  
    </div>  
  </main>
</template>

<script>
import { BTable, BFormGroup, BFormInput, BButton, BTd } from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import reportMixin from "@@/core/mixins/reportMixin";
import Loading from "@@/core/components/shared/Loading/Loading";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

export default {
  name: "storeBalanceReport",
  components: {
    BTable,
    BFormGroup,
    BFormInput,
    Treeselect,
    ProductSearch,
    BButton,
    Loading,
    BTd,
  },
  configProvider,
  data() {
    return {
      disabled: true,
      fields: [
        {
          key: "id",
          label: "شناسه محصول",
        },
        {
          key: "title",
          label: "عنوان",
        },
        {
          key: "quantity",
          label: "موجودی ",
        },
        {
          key: "purchase_price",
          label: "قیمت خرید(تومان) ",
        },
        {
          key: "sell_price",
          label: "قیمت فروش(تومان) ",
        },
        {
          key: 'show',
          label: 'تنوع'
        }
      ],
      page: 1,
      reports: null,
      sortBy: null,
      Product_id: "",
      selectedStore: null,
      productTitle: null,
      Variety_id: "",
      sortDesc: null,
      showModal: false,  
      isProduct: true,  
      varieties: [],
      categories: [],
      stores: [],
      category_id: null,
      totals: "",
      disabledRest: true,
    };
  },
  mixins: [reportMixin],

  created() {
    this.loadStores();
    this.loadCategories();
  },
  computed: {
      realOptions() {
        let temp = this.$root.addLabel(this.categories);
        temp.unshift({
            label: "ندارد",
            children: [],
            id: 0,
        });

        return temp;
      },
  },
  methods: {
    async showVarietiesBalance(product_id,title) {
      const params = { ids: [product_id] }; 
      this.isProduct = this.Variety_id ? false : true;
      if(this.isProduct){
        this.productTitle = title;
        const response = await this.$axios(`admin/products_excels`, {  
          params: params,  
        });  
        this.varieties = response.data.data.data;  
        this.showModal = true;  
      }
    },  
    closeModal() {  
      this.showModal = false;  
    },  
    async loadStores(){
        try {
            const response = await this.$axios.get("admin/stores");
            this.stores = response.data.data.stores;
            this.disabled = false;
        } catch (e) {
            this.$root.notify(e);
        } 
    },
    async loadCategories(){
        try {
            const response = await this.$axios.get("admin/categories?all=1");
            this.categories = response.data.data.categories;
            this.disabled = false;
        } catch (e) {
            this.$root.notify(e);
        } 
    },
    resetFilter() {
      this.Product_id = "";
      this.category_id = "";
      this.Variety_id = "";
      this.disabledRest = true;
      this.loadData();
    },
    doFilter() {
      this.loadData();
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    selectVariety(data) {
      this.Variety_id = data;
    },
    selectProduct(data) {
      this.Product_id = data;
    },
    async loadData() {
      this.disabledRest = false;
      try {
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/reports/store-balance-new",
          {
            params: {
              category_id: this.category_id == 0 ? null : this.category_id,
              store_id: this.selectedStore ? this.selectedStore.id : '',
              product_id: this.Product_id.id ? this.Product_id.id : '',
              variety_id: this.Variety_id.id ? this.Variety_id.id : '',
            },
          }
        );
        this.reports = response.data.data.reports;
        this.totals = response.data.data.totals;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    showVarieties(productId) {
      this.$root.$emit("bv::show::modal", "show-varieties-modal");
      this.showVarietiesProductId = productId;
    },
  },
};
</script>

<style>
.table-responsive-sm{
  overflow: auto;
  height: 500px;
}
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
th     { background:#eee; }
table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
.print-only {
  display: none;
}
#page-store-balance table tbody tr td:last-child{
  display: flex;justify-content: center;
}

@media print {
  #page-store-balance table tbody tr td:last-child{
    display: none;
  }
  #page-store-balance table thead tr th:last-child{
    display: none;
  }
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print button {
    position: static;
    left: 0;
    bottom: 0;
    border-radius: 0;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 80%;
  }

  #main-table th:last-child,
  #main-table td:last-child {
    display: none;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
